<div class="package-history-container">
  <!--Download Button-->
  <ion-row class="header-container ion-justify-content-between">
    <h3 class="heading">{{ CONSTANTS.PACKAGE_HISTORY }}</h3>
    @if (historyEvents.length > 0) {
      <ion-button class="download-btn" (click)="exportExcel()">
        <img [src]="IMAGES.EXCEL_WHITE" class="icon" alt="download" />
        <span class="text">{{ CONSTANTS.DOWNLOAD }}</span>
      </ion-button>
    }
  </ion-row>
  <!--------------->
  @if (historyEvents.length > 0) {
    <!--Events-->
    <!-- Top Warning Banners-->
    @for (banner of warningBanners; track banner) {
      @switch (banner.eventDescription) {
        <!--- RS LABEL --->
        @case (warningTypes.RS_LABEL) {
          <ion-card class="icon-card">
            <ion-item class="custom-item" lines="none">
              <ion-icon src="assets/tag.svg" class="icon"></ion-icon>
              <ion-label class="custom-label">
                <h3 class="title">
                  {{ CONSTANTS.RS_LABEL }}
                </h3>
                <p class="desc">
                  {{ CONSTANTS.DELIVERY_ADDRESS }}
                </p>
              </ion-label>
            </ion-item>
          </ion-card>
        }
        <!--------------->
        <!--- DRIVER FOLLOWUP --->
        @case (warningTypes.DRIVER_FOLLOWUP) {
          <ion-card class="icon-card">
            <ion-item class="custom-item" lines="none">
              <ion-icon src="assets/clipboard.svg" class="icon"></ion-icon>
              <ion-label class="custom-label">
                <h3 class="title">
                  {{ CONSTANTS.FOLLOW_UP }}
                </h3>
                <p class="desc">
                  {{ CONSTANTS.DELIVERY_ADDRESS }}
                </p>
              </ion-label>
            </ion-item>
          </ion-card>
        }
        <!--------------->
      }
    }
    <!---------------------->
    <div class="package-history-list">
      @for (packageHistoryItem of historyEvents; track packageHistoryItem) {
        @switch (packageHistoryItem?.eventDescription) {
          <!--- Data Movement --->
          @case (eventTypes.DATA_MOVEMENT) {
            <app-package-history-event
              [eventTime]="formatDateTime(packageHistoryItem.dateTimestamp)"
              [sourceData]="packageHistoryItem?.source"
              [eventType]="packageHistoryItem?.eventDescription?.toUpperCase()"
              [userIdData]="packageHistoryItem?.userID?.toUpperCase()"
            >
              <ion-row class="custom-row">
                <ion-col size="2">
                  <label class="small-label">
                    {{ CONSTANTS.ORIGINAL_ADDRESS }}
                  </label>
                  <p class="text">
                    {{ packageHistoryItem.originalAddress }}
                  </p>
                </ion-col>
                <ion-col size="auto">
                  <label class="small-label">
                    {{ CONSTANTS.PREFERRED_ADDRESS }}
                  </label>
                  <p class="text">{{ packageHistoryItem.preferredAddress }}</p>
                </ion-col>
                <ion-col size="auto">
                  <label class="small-label">{{ CONSTANTS.INSERT_TIME }}</label>
                  <p class="text">{{ packageHistoryItem.insertTime }}</p>
                </ion-col>
                <ion-col size="auto">
                  <label class="small-label">{{ CONSTANTS.UPDATE_TIME }}</label>
                  <p class="text">{{ packageHistoryItem.updateTime }}</p>
                </ion-col>
                <ion-col size="auto">
                  <label class="small-label">{{ CONSTANTS.VALID }}</label>
                  <p class="text">{{ packageHistoryItem.valid }}</p>
                </ion-col>
                <ion-col size="auto">
                  <label class="small-label">{{ CONSTANTS.PDI_ACTIVE }}</label>
                  <p class="text">{{ packageHistoryItem.pdiActive }}</p>
                </ion-col>
                <ion-col size="auto">
                  <label class="small-label">{{ CONSTANTS.LAT_LONG }}</label>
                  <p class="text">{{ packageHistoryItem.latLong }}</p>
                </ion-col>
                <ion-col size="auto">
                  <label class="small-label">{{
                    CONSTANTS.ADL_ELIGIBLE
                  }}</label>
                  <p class="text">{{ packageHistoryItem.adlEligible }}</p>
                </ion-col>
              </ion-row>
            </app-package-history-event>
          }
          <!----------------->
          <!--- Scheduled Delivery Date  --->
          @case (eventTypes.SCHEDULED_DELIVERY_DATE) {
            <app-package-history-event
              [eventTime]="formatDateTime(packageHistoryItem.dateTimestamp)"
              [sourceData]="packageHistoryItem?.source"
              [eventType]="packageHistoryItem?.eventDescription?.toUpperCase()"
              [userIdData]="packageHistoryItem?.userID?.toUpperCase()"
            >
              <ion-row class="custom-row">
                <ion-col size="auto">
                  <label class="small-label">{{ CONSTANTS.INSERT_TIME }}</label>
                  <p class="text">{{ packageHistoryItem.insertTime }}</p>
                </ion-col>
                <ion-col size="auto">
                  <label class="small-label">{{ CONSTANTS.UPDATE_TIME }}</label>
                  <p class="text">{{ packageHistoryItem.updateTime }}</p>
                </ion-col>
                <ion-col size="auto">
                  <label class="small-label">{{
                    CONSTANTS.SCHEDULED_DELIVERY_DATE
                  }}</label>
                  <p class="text">
                    {{ packageHistoryItem.scheduledDeliveryDate }}
                  </p>
                </ion-col>
              </ion-row>
            </app-package-history-event>
          }
          <!----------------->
          <!-- Fraud Hold -->
          @case (eventTypes.FRAUD_HOLD) {
            <app-package-history-event
              [eventTime]="formatDateTime(packageHistoryItem.dateTimestamp)"
              [sourceData]="packageHistoryItem?.source"
              [eventType]="packageHistoryItem?.eventDescription?.toUpperCase()"
              [userIdData]="packageHistoryItem?.userID?.toUpperCase()"
            >
              <ion-row class="custom-row">
                <ion-col size="auto">
                  <label class="small-label">
                    {{ CONSTANTS.EVENT_CREATED }}
                  </label>
                  <p class="text">{{ packageHistoryItem.eventCreated }}</p>
                </ion-col>
                <ion-col size="auto">
                  <label class="small-label">{{ CONSTANTS.FUTURE_DATE }}</label>
                  <p class="text">{{ packageHistoryItem.futureDate }}</p>
                </ion-col>
              </ion-row>
            </app-package-history-event>
          }
          <!-- RET_LOC_PEND -->
          @case (eventTypes.RET_LOC_PEND) {
            <app-package-history-event
              [eventTime]="formatDateTime(packageHistoryItem.dateTimestamp)"
              [sourceData]="packageHistoryItem?.source"
              [eventType]="packageHistoryItem?.eventDescription?.toUpperCase()"
              [userIdData]="packageHistoryItem?.userID?.toUpperCase()"
            >
              <ion-row class="custom-row">
                <ion-col size="auto">
                  <label class="small-label">
                    {{ CONSTANTS.EVENT_CREATED }}
                  </label>
                  <p class="text">{{ packageHistoryItem.eventCreated }}</p>
                </ion-col>
                <ion-col size="auto">
                  <label class="small-label">{{ CONSTANTS.FUTURE_DATE }}</label>
                  <p class="text">{{ packageHistoryItem.futureDate }}</p>
                </ion-col>
              </ion-row>
            </app-package-history-event>
          }
          <!-- RTS_PENDING -->
          @case (eventTypes.RTS_PENDING) {
            <app-package-history-event
              [eventTime]="formatDateTime(packageHistoryItem.dateTimestamp)"
              [sourceData]="packageHistoryItem?.source"
              [eventType]="packageHistoryItem?.eventDescription?.toUpperCase()"
              [userIdData]="packageHistoryItem?.userID?.toUpperCase()"
            >
              <ion-row class="custom-row">
                <ion-col size="auto">
                  <label class="small-label">
                    {{ CONSTANTS.EVENT_CREATED }}
                  </label>
                  <p class="text">{{ packageHistoryItem.eventCreated }}</p>
                </ion-col>
                <ion-col size="auto">
                  <label class="small-label">{{ CONSTANTS.FUTURE_DATE }}</label>
                  <p class="text">{{ packageHistoryItem.futureDate }}</p>
                </ion-col>
              </ion-row>
            </app-package-history-event>
          }
          <!----------------->
          <!--- Scan to Car --->
          @case (eventTypes.SCAN_TO_CAR) {
            <app-package-history-event
              [eventTime]="formatDateTime(packageHistoryItem.dateTimestamp)"
              [sourceData]="packageHistoryItem?.source"
              [eventType]="packageHistoryItem?.eventDescription?.toUpperCase()"
              [userIdData]="packageHistoryItem?.userID?.toUpperCase()"
            >
              <ion-row class="custom-row">
                <ion-col size="auto">
                  <label class="small-label"> {{ CONSTANTS.ROUTE_ID }} </label>
                  <p class="text">{{ packageHistoryItem.routeID }}</p>
                </ion-col>
                <ion-col size="auto">
                  <label class="small-label">{{ CONSTANTS.COMMIT_TIME }}</label>
                  <p class="text">{{ packageHistoryItem.commitTime }}</p>
                </ion-col>
                <ion-col size="auto">
                  <label class="small-label">
                    {{ CONSTANTS.UPDATED_COMMIT_TIME }}
                  </label>
                  <p class="text">{{ packageHistoryItem.updatedCommitTime }}</p>
                </ion-col>
                <ion-col size="auto">
                  <label class="small-label">{{
                    CONSTANTS.EVENT_CREATED
                  }}</label>
                  <p class="text">
                    {{ formatDateTime(packageHistoryItem.eventCreated) }}
                  </p>
                </ion-col>
                <ion-col size="auto">
                  <label class="small-label">{{
                    CONSTANTS.EVENT_STORED
                  }}</label>
                  <p class="text">
                    {{ formatDateTime(packageHistoryItem.eventStored) }}
                  </p>
                </ion-col>
                <ion-col size="auto">
                  <label class="small-label">{{ CONSTANTS.INTERCEPT }}</label>
                  <p class="text">{{ packageHistoryItem.intercept }}</p>
                </ion-col>
                <ion-col size="auto">
                  <label class="small-label">{{ CONSTANTS.DUPLICATE }}</label>
                  <p class="text">{{ packageHistoryItem.duplicate }}</p>
                </ion-col>
                <ion-col size="auto">
                  <label class="small-label">{{ CONSTANTS.REMOVAL }}</label>
                  <p class="text">{{ packageHistoryItem.removal }}</p>
                </ion-col>
                <ion-col size="auto">
                  <label class="small-label">{{ CONSTANTS.DFU }}</label>
                  <p class="text">{{ packageHistoryItem.dfu }}</p>
                </ion-col>
                <ion-col size="auto">
                  <label class="small-label">{{ CONSTANTS.RS_LABEL }}</label>
                  <p class="text">{{ packageHistoryItem.rsLabel }}</p>
                </ion-col>
              </ion-row>
            </app-package-history-event>
          }
          <!----------------->
          <!--- Address Correction --->
          @case (eventTypes.ADDRESS_CORRECTION) {
            <app-package-history-event
              [eventTime]="formatDateTime(packageHistoryItem.dateTimestamp)"
              [sourceData]="packageHistoryItem?.source"
              [eventType]="packageHistoryItem?.eventDescription?.toUpperCase()"
              [userIdData]="packageHistoryItem?.userID?.toUpperCase()"
            >
              <ion-row class="custom-row">
                <ion-col size="12">
                  <ion-row>
                    <ion-col size="auto" class="mt-2 mb-2">
                      <label class="small-label">{{
                        CONSTANTS.ORIGINAL_ADDRESS
                      }}</label>
                      <p class="text">
                        {{ packageHistoryItem.originalAddress }}
                      </p>
                    </ion-col>
                    <ion-col size="auto">
                      <label class="small-label">{{ CONSTANTS.VALID }}</label>
                      <p class="text">{{ packageHistoryItem.valid }}</p>
                    </ion-col>
                    <ion-col size="auto">
                      <label class="small-label">{{
                        CONSTANTS.LAT_LONG
                      }}</label>
                      <p class="text">{{ packageHistoryItem.latLong }}</p>
                    </ion-col>
                  </ion-row>
                </ion-col>
                <ion-col size="12" class="mt-2 mb-2">
                  <ion-row>
                    <ion-col size="auto">
                      <label class="small-label">{{
                        CONSTANTS.CORRECTED_ADDRESS
                      }}</label>
                      <p class="text">
                        {{ packageHistoryItem.correctedAddress }}
                      </p>
                    </ion-col>
                    <ion-col size="auto">
                      <label class="small-label">{{ CONSTANTS.VALID }}</label>
                      <p class="text">
                        {{ packageHistoryItem.correctedValid }}
                      </p>
                    </ion-col>
                    <ion-col size="auto">
                      <label class="small-label">{{
                        CONSTANTS.LAT_LONG
                      }}</label>
                      <p class="text">
                        {{ packageHistoryItem.correctedLatLong }}
                      </p>
                    </ion-col>
                  </ion-row>
                </ion-col>
                @if (packageHistoryItem.routeID) {
                  <ion-col size="auto">
                    <label class="small-label">
                      {{ CONSTANTS.ROUTE_ID }}
                    </label>
                    <p class="text">{{ packageHistoryItem.routeID }}</p>
                  </ion-col>
                }
                @if (packageHistoryItem.commitTime) {
                  <ion-col size="auto">
                    <label class="small-label">{{
                      CONSTANTS.COMMIT_TIME
                    }}</label>
                    <p class="text">{{ packageHistoryItem.commitTime }}</p>
                  </ion-col>
                }
                @if (packageHistoryItem.updatedCommitTime) {
                  <ion-col size="auto">
                    <label class="small-label">
                      {{ CONSTANTS.UPDATED_COMMIT_TIME }}
                    </label>
                    <p class="text">
                      {{ packageHistoryItem.updatedCommitTime }}
                    </p>
                  </ion-col>
                }
                <ion-col size="auto">
                  <label class="small-label">{{
                    CONSTANTS.EVENT_CREATED
                  }}</label>
                  <p class="text">
                    {{ formatDateTime(packageHistoryItem.eventCreated) }}
                  </p>
                </ion-col>
                @if (packageHistoryItem.intercept) {
                  <ion-col size="auto">
                    <label class="small-label">{{ CONSTANTS.INTERCEPT }}</label>
                    <p class="text">{{ packageHistoryItem.intercept }}</p>
                  </ion-col>
                }
                @if (packageHistoryItem.duplicate) {
                  <ion-col size="auto" class="mt-2 mb-2">
                    <label class="small-label">{{ CONSTANTS.DUPLICATE }}</label>
                    <p class="text">{{ packageHistoryItem.duplicate }}</p>
                  </ion-col>
                }
                @if (packageHistoryItem.removal) {
                  <ion-col size="auto" class="mt-2 mb-2">
                    <label class="small-label">{{ CONSTANTS.REMOVAL }}</label>
                    <p class="text">{{ packageHistoryItem.removal }}</p>
                  </ion-col>
                }
                <ion-col size="auto">
                  <label class="small-label">{{ CONSTANTS.PIN_DROP }}</label>
                  <p class="text">{{ packageHistoryItem.pinDrop }}</p>
                </ion-col>
              </ion-row>
            </app-package-history-event>
          }
          <!----------------->
          <!--- Redeliver --->
          @case (eventTypes.REDELIVER) {
            <app-package-history-event
              [eventTime]="formatDateTime(packageHistoryItem.dateTimestamp)"
              [sourceData]="packageHistoryItem?.source"
              [eventType]="packageHistoryItem?.eventDescription?.toUpperCase()"
              [userIdData]="packageHistoryItem?.userID?.toUpperCase()"
            >
              <ion-row class="custom-row">
                <ion-col size="auto">
                  <label class="small-label">{{
                    CONSTANTS.EVENT_CREATED
                  }}</label>
                  <p class="text">
                    {{ formatDateTime(packageHistoryItem.eventCreated) }}
                  </p>
                </ion-col>
                <ion-col size="auto">
                  <label class="small-label">{{ CONSTANTS.FUTURE_DATE }}</label>
                  <p class="text">
                    {{ packageHistoryItem?.futureDate }}
                  </p>
                </ion-col>
              </ion-row>
            </app-package-history-event>
          }
          <!----------------->
          <!--- Delivery Status --->
          @case (eventTypes.DELIVERY_STATUS) {
            <app-package-history-event
              [eventTime]="formatDateTime(packageHistoryItem.dateTimestamp)"
              [sourceData]="packageHistoryItem?.source"
              [eventType]="packageHistoryItem?.eventDescription?.toUpperCase()"
              [userIdData]="packageHistoryItem?.userID?.toUpperCase()"
            >
              <ion-row class="custom-row">
                <ion-col size="2">
                  <label class="small-label"
                    >{{ CONSTANTS.DELIVERY_ADDRESS }}
                  </label>
                  <p class="text">
                    {{ packageHistoryItem.deliveyAddress }}
                  </p>
                </ion-col>
                <ion-col size="auto">
                  <label class="small-label">{{ CONSTANTS.ROUTE_ID }}</label>
                  <p class="text">{{ packageHistoryItem.routeID }}</p>
                </ion-col>
                <ion-col size="auto">
                  <label class="small-label">{{ CONSTANTS.STOP_TIME }}</label>
                  <p class="text">
                    {{ formatDateTime(packageHistoryItem.stopTime) }}
                  </p>
                </ion-col>
                <ion-col size="auto">
                  <label class="small-label">
                    {{ CONSTANTS.DELIVERY_STATE }}
                  </label>
                  <p class="text">{{ packageHistoryItem.delivered }}</p>
                </ion-col>
                <ion-col size="auto">
                  <label class="small-label">{{ CONSTANTS.REASON }}</label>
                  <p class="text">{{ packageHistoryItem.reason }}</p>
                </ion-col>
              </ion-row>
            </app-package-history-event>
          }
          <!----------------->
          <!--- Pickup Scan --->
          @case (eventTypes.PICKUP_SCAN) {
            <app-package-history-event
              [eventTime]="formatDateTime(packageHistoryItem.dateTimestamp)"
              [sourceData]="packageHistoryItem?.source"
              [eventType]="packageHistoryItem?.eventDescription?.toUpperCase()"
              [userIdData]="packageHistoryItem?.userID?.toUpperCase()"
            >
              <ion-row class="custom-row">
                <ion-col size="2">
                  <label class="small-label">{{ CONSTANTS.ROUTE_ID }} </label>
                  <p class="text">
                    {{ packageHistoryItem.routeID }}
                  </p>
                </ion-col>
                <ion-col size="auto">
                  <label class="small-label">{{
                    CONSTANTS.PICKUP_ADDRESS
                  }}</label>
                  <p class="text">{{ packageHistoryItem.pickupAddress }}</p>
                </ion-col>
                <ion-col size="auto">
                  <label class="small-label">{{ CONSTANTS.STOP_TIME }}</label>
                  <p class="text">
                    {{ formatDateTime(packageHistoryItem.stopTime) }}
                  </p>
                </ion-col>
              </ion-row>
            </app-package-history-event>
          }
          <!----------------->
          <!--- Exception Processing --->
          @case (eventTypes.EXCEPTION_PROCESSING) {
            <app-package-history-event
              [eventTime]="formatDateTime(packageHistoryItem.dateTimestamp)"
              [sourceData]="packageHistoryItem?.source"
              [eventType]="packageHistoryItem?.eventDescription?.toUpperCase()"
              [userIdData]="packageHistoryItem?.userID?.toUpperCase()"
            >
              <ion-row class="custom-row">
                <ion-col size="2">
                  <label class="small-label">
                    {{ CONSTANTS.ORIGINAL_ADDRESS }}
                  </label>
                  <p class="text">
                    {{ packageHistoryItem.originalAddress }}
                  </p>
                </ion-col>
                <ion-col size="2">
                  <label class="small-label">
                    {{ CONSTANTS.NEW_ADDRESS }}
                  </label>
                  <p class="text">
                    {{ packageHistoryItem.newAddress }}
                  </p>
                </ion-col>
                <ion-col size="auto">
                  <label class="small-label">{{
                    CONSTANTS.EVENT_CREATED
                  }}</label>
                  <p class="text">
                    {{ formatDateTime(packageHistoryItem.eventCreated) }}
                  </p>
                </ion-col>
                <ion-col size="auto">
                  <label class="small-label">{{
                    CONSTANTS.EVENT_STORED
                  }}</label>
                  <p class="text">
                    {{ formatDateTime(packageHistoryItem.eventstorted) }}
                  </p>
                </ion-col>
                <ion-col size="auto">
                  <label class="small-label">{{ CONSTANTS.REASON }}</label>
                  <p class="text">{{ packageHistoryItem.reason }}</p>
                </ion-col>
                <ion-col size="auto">
                  <label class="small-label">{{ CONSTANTS.STATUS }}</label>
                  <p class="text">{{ packageHistoryItem.status }}</p>
                </ion-col>
                <ion-col size="auto">
                  <label class="small-label">{{ CONSTANTS.RESOLUTION }}</label>
                  <p class="text">{{ packageHistoryItem.resolution }}</p>
                </ion-col>
              </ion-row>
            </app-package-history-event>
          }
          <!----------------->
          <!--- Building Scan --->
          @case (eventTypes.BUILDING_SCAN) {
            <app-package-history-event
              [eventTime]="formatDateTime(packageHistoryItem.dateTimestamp)"
              [sourceData]="packageHistoryItem?.source"
              [eventType]="packageHistoryItem?.eventDescription?.toUpperCase()"
              [userIdData]="packageHistoryItem?.userID?.toUpperCase()"
            >
              <ion-row class="custom-row">
                <ion-col size="auto">
                  <label class="small-label"> {{ CONSTANTS.ROUTE_ID }} </label>
                  <p class="text">{{ packageHistoryItem.routeID }}</p>
                </ion-col>
                <ion-col size="auto">
                  <label class="small-label">{{
                    CONSTANTS.EVENT_CREATED
                  }}</label>
                  <p class="text">
                    {{ formatDateTime(packageHistoryItem.eventCreated) }}
                  </p>
                </ion-col>
                <ion-col size="auto">
                  <label class="small-label">{{
                    CONSTANTS.EVENT_STORED
                  }}</label>
                  <p class="text">
                    {{ formatDateTime(packageHistoryItem.eventstorted) }}
                  </p>
                </ion-col>
                <ion-col size="auto">
                  <label class="small-label">{{ CONSTANTS.REASON }}</label>
                  <p class="text">{{ packageHistoryItem.reason }}</p>
                </ion-col>
                <ion-col size="auto">
                  <label class="small-label">{{ CONSTANTS.STATUS }}</label>
                  <p class="text">{{ packageHistoryItem.status }}</p>
                </ion-col>
                <ion-col size="auto">
                  <label class="small-label">{{ CONSTANTS.RESOLUTION }}</label>
                  <p class="text">{{ packageHistoryItem.resolution }}</p>
                </ion-col>
              </ion-row>
            </app-package-history-event>
          }
          <!----------------->
          <!--- Handover Scan --->
          @case (eventTypes.HANDOVER_SCAN) {
            <app-package-history-event
              [eventTime]="formatDateTime(packageHistoryItem.dateTimestamp)"
              [sourceData]="packageHistoryItem?.source"
              [eventType]="packageHistoryItem?.eventDescription?.toUpperCase()"
              [userIdData]="packageHistoryItem?.userID?.toUpperCase()"
            >
              <ion-row class="custom-row">
                <ion-col size="auto">
                  <label class="small-label"> {{ CONSTANTS.ROUTE_ID }} </label>
                  <p class="text">{{ packageHistoryItem.routeID }}</p>
                </ion-col>
                <ion-col size="auto">
                  <label class="small-label">{{
                    CONSTANTS.EVENT_CREATED
                  }}</label>
                  <p class="text">
                    {{ formatDateTime(packageHistoryItem.eventCreated) }}
                  </p>
                </ion-col>
                <ion-col size="auto">
                  <label class="small-label">{{
                    CONSTANTS.EVENT_STORED
                  }}</label>
                  <p class="text">
                    {{ formatDateTime(packageHistoryItem.eventstorted) }}
                  </p>
                </ion-col>
                <ion-col size="auto">
                  <label class="small-label">{{ CONSTANTS.REFERENCE }}</label>
                  <p class="text">
                    {{
                      packageHistoryItem.referenceId ||
                        packageHistoryItem.referenceID
                    }}
                  </p>
                </ion-col>
              </ion-row>
            </app-package-history-event>
          }

          @default {
            <app-package-history-event
              [eventTime]="formatDateTime(packageHistoryItem.dateTimestamp)"
              [sourceData]="packageHistoryItem?.source"
              [eventType]="packageHistoryItem?.eventDescription?.toUpperCase()"
              [userIdData]="packageHistoryItem?.userID?.toUpperCase()"
            >
              <ion-row class="custom-row">
                <ion-col size="auto">
                  <label class="small-label">
                    {{ CONSTANTS.EVENT_CREATED }}
                  </label>
                  <p class="text">{{ packageHistoryItem?.eventCreated }}</p>
                </ion-col>
                <ion-col size="auto">
                  <label class="small-label">{{ CONSTANTS.FUTURE_DATE }}</label>
                  <p class="text">{{ packageHistoryItem?.futureDate }}</p>
                </ion-col>
              </ion-row>
            </app-package-history-event>
          }
          <!----------------->
        }
      }
    </div>
    <!--------------->
  }

  <!--No Results Found-->
  @if (historyEvents.length === 0) {
    <app-no-result [message]="NO_RESULTS"></app-no-result>
  }
  <!--------------->
</div>
